// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-page {
  --profile-brand: #a61b34;
  --profile-brand-border: rgba(166, 27, 52, 0.28);
  --profile-surface: #252525;
  --profile-surface-raised: #1a1a1a;
  --profile-border: #374151;
  --profile-text: #e5e7eb;
  --profile-text-muted: #9ca3af;
  --profile-text-dim: #6b7280;
  --profile-success: #22c55e;

  flex: 1 1;
  width: 100%;
  max-width: none;
  box-sizing: border-box;
  background-color: #0a0a0a;
  color: #ffffff;
  padding: 32px 40px 40px;
}

.profile-header {
  margin-bottom: 32px;
}

.profile-header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  color: #ffffff;
}

.profile-header p {
  margin: 8px 0 0 0;
  font-size: 14px;
  color: #9ca3af;
}

.profile-form {
  width: 100%;
}

.profile-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px 40px;
  align-items: start;
}

.profile-form-span-2 {
  grid-column: 1 / -1;
}

/* Una sola columna (izquierda); la derecha queda libre en esa fila */
.profile-form-col-1 {
  grid-column: 1;
}

.profile-form-empty-cell {
  grid-column: 2;
  min-width: 0;
  pointer-events: none;
}

@media (max-width: 900px) {
  .profile-form-grid {
    grid-template-columns: 1fr;
  }

  .profile-form-span-2 {
    grid-column: 1;
  }

  .profile-form-col-1 {
    grid-column: 1;
  }

  .profile-form-empty-cell {
    display: none;
  }
}

.profile-form-footer {
  grid-column: 1 / -1;
  margin-top: 8px;
}

.profile-form-footer .profile-submit-btn {
  width: 100%;
  max-width: 320px;
}

@media (max-width: 900px) {
  .profile-form-footer .profile-submit-btn {
    max-width: none;
  }
}

.profile-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.profile-form .form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #e5e7eb;
}

.profile-form .form-group input {
  padding: 12px 16px;
  border: 1px solid #374151;
  border-radius: 8px;
  font-size: 16px;
  background: #111;
  color: #ffffff;
  transition: border-color 0.2s;
}

.profile-form .form-group input::placeholder {
  color: #6b7280;
}

.profile-form .form-group input:focus {
  outline: none;
  border-color: #A61B34;
}

.profile-form .form-group input:disabled {
  background-color: #1f2937;
  cursor: not-allowed;
  opacity: 0.7;
}

.profile-form .password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.profile-form .password-input-wrapper input {
  padding-right: 48px;
  width: 100%;
}

.profile-form .password-toggle-btn {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s;
  border-radius: 4px;
}

.profile-form .password-toggle-btn:hover {
  color: #ffffff;
}

.profile-submit-btn {
  padding: 14px;
  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s, transform 0.1s;
}

.profile-submit-btn:hover:not(:disabled) {
  opacity: 0.95;
  transform: translateY(-1px);
}

.profile-submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.profile-form .form-group input.profile-input--error {
  border-color: #ef4444;
}

.profile-new-password-block {
  gap: 10px;
}

.profile-confirm-password-group {
  margin-top: 0;
}

.profile-password-checklist {
  margin-top: 4px;
  padding: 14px 16px;
  background: var(--profile-surface);
  border: 1px solid var(--profile-brand-border);
  border-radius: 10px;
}

.profile-password-checklist-title {
  margin: 0 0 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--profile-text);
  line-height: 1.35;
}

.profile-password-checklist-items {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.profile-password-rule {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 13px;
  line-height: 1.4;
  color: var(--profile-text-muted);
}

.profile-password-rule--met {
  color: var(--profile-text);
}

.profile-password-rule-icon {
  flex-shrink: 0;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1px;
}

.profile-password-check-icon {
  color: var(--profile-success);
}

.profile-password-rule-dash {
  color: var(--profile-text-dim);
  font-weight: 600;
  font-size: 14px;
  line-height: 1;
}

.profile-password-rule-text {
  flex: 1 1;
  min-width: 0;
}

.profile-password-field-error {
  margin: 4px 0 0;
  font-size: 13px;
  color: #f87171;
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ProfilePage.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,+CAA+C;EAC/C,0BAA0B;EAC1B,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;;EAE1B,SAAO;EACP,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qEAAqE;AACrE;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,kCAAkC;EAClC,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".profile-page {\n  --profile-brand: #a61b34;\n  --profile-brand-border: rgba(166, 27, 52, 0.28);\n  --profile-surface: #252525;\n  --profile-surface-raised: #1a1a1a;\n  --profile-border: #374151;\n  --profile-text: #e5e7eb;\n  --profile-text-muted: #9ca3af;\n  --profile-text-dim: #6b7280;\n  --profile-success: #22c55e;\n\n  flex: 1;\n  width: 100%;\n  max-width: none;\n  box-sizing: border-box;\n  background-color: #0a0a0a;\n  color: #ffffff;\n  padding: 32px 40px 40px;\n}\n\n.profile-header {\n  margin-bottom: 32px;\n}\n\n.profile-header h1 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.profile-header p {\n  margin: 8px 0 0 0;\n  font-size: 14px;\n  color: #9ca3af;\n}\n\n.profile-form {\n  width: 100%;\n}\n\n.profile-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px 40px;\n  align-items: start;\n}\n\n.profile-form-span-2 {\n  grid-column: 1 / -1;\n}\n\n/* Una sola columna (izquierda); la derecha queda libre en esa fila */\n.profile-form-col-1 {\n  grid-column: 1;\n}\n\n.profile-form-empty-cell {\n  grid-column: 2;\n  min-width: 0;\n  pointer-events: none;\n}\n\n@media (max-width: 900px) {\n  .profile-form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .profile-form-span-2 {\n    grid-column: 1;\n  }\n\n  .profile-form-col-1 {\n    grid-column: 1;\n  }\n\n  .profile-form-empty-cell {\n    display: none;\n  }\n}\n\n.profile-form-footer {\n  grid-column: 1 / -1;\n  margin-top: 8px;\n}\n\n.profile-form-footer .profile-submit-btn {\n  width: 100%;\n  max-width: 320px;\n}\n\n@media (max-width: 900px) {\n  .profile-form-footer .profile-submit-btn {\n    max-width: none;\n  }\n}\n\n.profile-form .form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.profile-form .form-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #e5e7eb;\n}\n\n.profile-form .form-group input {\n  padding: 12px 16px;\n  border: 1px solid #374151;\n  border-radius: 8px;\n  font-size: 16px;\n  background: #111;\n  color: #ffffff;\n  transition: border-color 0.2s;\n}\n\n.profile-form .form-group input::placeholder {\n  color: #6b7280;\n}\n\n.profile-form .form-group input:focus {\n  outline: none;\n  border-color: #A61B34;\n}\n\n.profile-form .form-group input:disabled {\n  background-color: #1f2937;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.profile-form .password-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.profile-form .password-input-wrapper input {\n  padding-right: 48px;\n  width: 100%;\n}\n\n.profile-form .password-toggle-btn {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  color: #9ca3af;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.2s;\n  border-radius: 4px;\n}\n\n.profile-form .password-toggle-btn:hover {\n  color: #ffffff;\n}\n\n.profile-submit-btn {\n  padding: 14px;\n  background: linear-gradient(135deg, #A61B34 0%, #8B1528 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s, transform 0.1s;\n}\n\n.profile-submit-btn:hover:not(:disabled) {\n  opacity: 0.95;\n  transform: translateY(-1px);\n}\n\n.profile-submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.profile-form .form-group input.profile-input--error {\n  border-color: #ef4444;\n}\n\n.profile-new-password-block {\n  gap: 10px;\n}\n\n.profile-confirm-password-group {\n  margin-top: 0;\n}\n\n.profile-password-checklist {\n  margin-top: 4px;\n  padding: 14px 16px;\n  background: var(--profile-surface);\n  border: 1px solid var(--profile-brand-border);\n  border-radius: 10px;\n}\n\n.profile-password-checklist-title {\n  margin: 0 0 10px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--profile-text);\n  line-height: 1.35;\n}\n\n.profile-password-checklist-items {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.profile-password-rule {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--profile-text-muted);\n}\n\n.profile-password-rule--met {\n  color: var(--profile-text);\n}\n\n.profile-password-rule-icon {\n  flex-shrink: 0;\n  width: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 1px;\n}\n\n.profile-password-check-icon {\n  color: var(--profile-success);\n}\n\n.profile-password-rule-dash {\n  color: var(--profile-text-dim);\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1;\n}\n\n.profile-password-rule-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.profile-password-field-error {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #f87171;\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
